import { useContext } from 'react';

import { ContextScopeError } from '~src/errors/ContextScopeError';

import { PermissionsContext } from '../contexts/PermissionsContext';

export function usePermissions() {
  const context = useContext(PermissionsContext);

  if (!context) {
    throw new ContextScopeError('usePermissions', 'PermissionsProvider');
  }

  return context;
}
